<template>
    <div id="index">
        <div class="container">
            <div>
                <img style="width:100%;" src="@/assets/images/steps.png">
                <div class="clearfix" style="padding:10px;">
                    <a href="https://play.google.com/store/apps/details?id=com.creatzy.swif"><img class="checkedimage" style="float:left;" src="@/assets/images/googleplay.png"></a>
                    <a href="https://apps.apple.com/my/app/swif/id1514744001"><img class="checkedimage" style="float:right;" src="@/assets/images/applestore.png"></a>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.checkedimage{
    width: 50%;
}
</style>
<script>
export default{
    name: 'index'
}
</script>